import React from 'react'

export default function CandidateInfo ({ applicationResults, nin, ageCalculated }: { applicationResults: any, nin: any, ageCalculated : any }) {
  return (
 <table className='candidate-info-table'>
                  <tbody>
                    {/* Candidate Type */}
                    <tr>
                      <td className='candidate-info-table__label'>Candidate Type:</td>
                      <td className='candidate-info-table__field' colSpan={applicationResults?.formData?.candidateRole === 'spc' ? 1 : 3}>
                        <div className='radio-group-inline '>
                         <label className='radio-option-inline'>{applicationResults?.formData?.candidateRole === 'spc' ? 'Specialist' : 'General Duty'}</label>
                        </div>
                      </td>
                      {applicationResults?.formData?.candidateRole === 'spc' && <td className='candidate-info-table__label'>Vacancy Field:</td>}
                     {applicationResults?.formData?.candidateRole === 'spc' && <td className='candidate-info-table__field' >
                        <div className='radio-group-inline '>

                          {applicationResults?.formData?.candidateRole === 'spc' && <label className='radio-option-inline'>

                            <span>{applicationResults?.formData?.roleAttrib?.vacancyField}</span>
                          </label>}
                        </div>
                      </td>}
                    </tr>

                    {/* Specialist Field (conditional)
                    {candidateType === 'Specialist' && (
                      <tr>
                        <td className='candidate-info-table__label'>Specialist Field:</td>
                        <td className='candidate-info-table__field' colSpan={3}>
                          <input
                            type='text'
                            className='table-input'
                            placeholder='Enter specialist field'
                            // {...register('candidateInfo.specialistField')}
                          />
                        </td>
                      </tr>
                    )} */}

                    {/* NIN and Reference Number */}
                    <tr>
                      <td className='candidate-info-table__label'>National Identity Number (NIN):</td>
                      <td className='candidate-info-table__field'>
                       <label className='radio-option-inline'> {nin }</label>
                      </td>
                      <td className='candidate-info-table__label'>Reference No:</td>
                      <td className='candidate-info-table__field'>
                                <label className='radio-option-inline'> {applicationResults?.formData?.referenceNo}</label>
                      </td>
                    </tr>

                    {/* Full Name */}
                    <tr>
                      <td className='candidate-info-table__label'>Full Name:</td>
                      <td className='candidate-info-table__field' colSpan={3}>
                           <label className='radio-option-inline'> {applicationResults?.formData?.surname} {applicationResults?.formData?.middlename} {applicationResults?.formData?.firstname}</label>
                      </td>
                    </tr>

                    {/* State of Origin and LGA */}
                    <tr>
                      <td className='candidate-info-table__label'>State of Origin:</td>
                      <td className='candidate-info-table__field'>
                         <label className='radio-option-inline'> {applicationResults?.formData?.stateOfPermanent}</label>
                      </td>
                      <td className='candidate-info-table__label'>LGA:</td>
                      <td className='candidate-info-table__field'>
                         <label className='radio-option-inline'> {applicationResults?.formData?.lgaOfPermanent}</label>
                      </td>
                    </tr>

                    {/* Date of Birth and Age */}
                    <tr>
                      <td className='candidate-info-table__label'>Date of Birth:</td>
                      <td className='candidate-info-table__field'>
                                                 <label className='radio-option-inline'> {applicationResults?.formData?.dob}</label>
                      </td>
                      <td className='candidate-info-table__label'>Age:</td>
                      <td className='candidate-info-table__field'>
                        <label className='radio-option-inline'> {ageCalculated !== null ? ageCalculated : ''}</label>
                      </td>
                    </tr>

                    {/* Gender */}
                    <tr>
                      <td className='candidate-info-table__label'>Gender:</td>
                      <td className='candidate-info-table__field' colSpan={3}>
                        <div className='radio-group-inline'>
                          <label className='radio-option-inline'>{applicationResults?.formData?.gender === 'm' ? 'Male' : 'Female'}</label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
  )
}
